import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { ShellActions, State } from "@opm/ng-core";
import { ProfileService } from "core/services/profile.service";
import { catchError, mergeMap } from "rxjs/operators";
import { Affiliation } from "../../../shared/models/affiliation";
import { Agency } from "../../../shared/models/agency";
import { BUSCode } from "../../../shared/models/busCode";
import { CPDFCode } from "../../../shared/models/cpdfCode";
import { Union } from "../../../shared/models/union";
import { Lookups } from "../lookup-state";

@Injectable({
	providedIn: 'root'
})
export class LookupEffects {
	constructor(
		private actions$: Actions,
		private profileService: ProfileService,
		private store: Store<State>) {
	}

	loadAgencies$ = createEffect(() => this.actions$.pipe(
		ofType(Lookups.loadAgencies),
		mergeMap((action) => this.profileService.getAgencies().pipe(
			mergeMap((response: string[]) => {
				return [
					Lookups.updateAgencies(response),
				]
			}),
			catchError(err => [ShellActions.setErrorMessage({ message: err.message, source: '' })])
		))
  ));

  loadAgencyObjects$ = createEffect(() => this.actions$.pipe(
    ofType(Lookups.loadAgencyObjects),
    mergeMap((action) => this.profileService.getAgencyObjects().pipe(
      mergeMap((response: Agency[]) => {
        return [
          Lookups.updateAgencyObjects(response),
        ]
      }),
      catchError(err => [ShellActions.setErrorMessage({ message: err.message, source: '' })])
    ))
  ));

	loadUnions$ = createEffect(() => this.actions$.pipe(
		ofType(Lookups.loadUnions),
		mergeMap((action) => this.profileService.getUnions().pipe(
			mergeMap((response: string[]) => {
				return [
					Lookups.updateUnions(response),
				]
			}),
			catchError(err => [ShellActions.setErrorMessage({ message: err.message, source: '' })])
		))
  ));

  loadUnionObjects$ = createEffect(() => this.actions$.pipe(
    ofType(Lookups.loadUnionObjects),
    mergeMap((action) => this.profileService.getUnionObjects().pipe(
      mergeMap((response: Union[]) => {
        return [
          Lookups.updateUnionObjects(response),
        ]
      }),
      catchError(err => [ShellActions.setErrorMessage({ message: err.message, source: '' })])
    ))
  ));

	loadOlmrNumbers$ = createEffect(() => this.actions$.pipe(
		ofType(Lookups.loadOlmrNumbers),
		mergeMap((action) => this.profileService.getOlmrNumbers().pipe(
			mergeMap((response: string[]) => {
				return [
					Lookups.updateOlmrNumbers(response),
				]
			}),
			catchError(err => [ShellActions.setErrorMessage({ message: err.message, source: '' })])
		))
	));

  loadBusCodes$ = createEffect(() => this.actions$.pipe(
    ofType(Lookups.loadBusCodes),
    mergeMap((action) => this.profileService.getBusCodes().pipe(
      mergeMap((response: string[]) => {
        return [
          Lookups.updateBusCodes(response),
        ]
      }),
      catchError(err => [ShellActions.setErrorMessage({ message: err.message, source: '' })])
    ))
  ));

  loadBusCodeObjects$ = createEffect(() => this.actions$.pipe(
    ofType(Lookups.loadBusCodeObjects),
    mergeMap((action) => this.profileService.getBusCodeObjects().pipe(
      mergeMap((response: BUSCode[]) => {
        return [
          Lookups.updateBusCodeObjects(response),
        ]
      }),
      catchError(err => [ShellActions.setErrorMessage({ message: err.message, source: '' })])
    ))
  ));

  loadCpdfCodeObjects$ = createEffect(() => this.actions$.pipe(
    ofType(Lookups.loadCpdfCodeObjects),
    mergeMap((action) => this.profileService.getCpdfCodeObjects().pipe(
      mergeMap((response: CPDFCode[]) => {
        return [
          Lookups.updateCpdfCodeObjects(response),
        ]
      }),
      catchError(err => [ShellActions.setErrorMessage({ message: err.message, source: '' })])
    ))
  ));

  loadAffiliationObjects$ = createEffect(() => this.actions$.pipe(
    ofType(Lookups.loadAffiliationObjects),
    mergeMap((action) => this.profileService.getAffiliationObjects().pipe(
      mergeMap((response: Affiliation[]) => {
        return [
          Lookups.updateAffiliationObjects(response),
        ]
      }),
      catchError(err => [ShellActions.setErrorMessage({ message: err.message, source: '' })])
    ))
  ));
}
